import { ALL_APPS, ALL_VIEW_IDS } from 'constants/appConstants';
import MainCardWrapper from 'layout/MainLayout/MainCardWrapper';
import PermissionsRouteWrapper from 'views/pages/components/PermissionsRouteWrapper';
import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import NoSubOrgRouteWrapper from 'views/pages/components/NoSubOrgRouteWrapper';
import { ORG_PREFERENCES_TABS } from 'views/org/OrgPreferences';
import { Navigate } from 'react-router-dom';

const Org = Loadable(lazy(() => import('views/org/OrgPreferences')));

export const OrgSettingsRoutes = [
  {
    path: `${ALL_APPS.ORG_SETTINGS.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.ORG_SETTINGS.id,
        }}
      >
        <Org />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_APPS.ORG_SETTINGS.views?.ORG_INFO?.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.ORG_SETTINGS.id,
          view: ALL_VIEW_IDS.ORG_INFO,
        }}
      >
        <Navigate
          to={`${ALL_APPS.ORG_SETTINGS.path}?tab=${ORG_PREFERENCES_TABS.INFO}`}
          replace
        />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_APPS.ORG_SETTINGS.views?.ORG_PREFERENCES?.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{ app: ALL_APPS.ORG_SETTINGS.id }}
      >
        <Navigate
          to={`${ALL_APPS.ORG_SETTINGS.path}?tab=${ORG_PREFERENCES_TABS.PARTS}`}
          replace
        />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_APPS.ORG_SETTINGS.views?.ORG_SUBORGS?.path}`,
    element: (
      <MainCardWrapper>
        <PermissionsRouteWrapper
          permissionScope={{
            app: ALL_APPS.ORG_SETTINGS.id,
            view: ALL_VIEW_IDS.ORG_SUBORGS,
          }}
        >
          <NoSubOrgRouteWrapper>
            <Navigate
              to={`${ALL_APPS.ORG_SETTINGS.path}?tab=${ORG_PREFERENCES_TABS.SUB_ORGS}`}
              replace
            />
          </NoSubOrgRouteWrapper>
        </PermissionsRouteWrapper>
      </MainCardWrapper>
    ),
  },
];
